module.exports = __webpack_public_path__ + "img/1 (18).12ae8c61.png";